import rest from "../script/rest";
import commonUtils from "../script/utils/commonUtils";

class FieldRest {

    async synchronize() {
        const url = "/rest/field/synchronize";
        await rest.get(url);
    }

    async downloadFieldsByAntennaId(antennaId) {
        const url = "/rest/field/downloadFieldsZipByAntennaId"
            + "?antennaId=" + antennaId;
        await commonUtils.download(url);
    }
}
const fieldRest = new FieldRest();
window.fieldRest = fieldRest;
export default fieldRest;